import Marker from 'components/Marker'
import FilterBar from 'components/FilterBar'
import ClusterMarker from 'components/ClusterMarker'
import PageBase from 'components/PageBase'
import SearchBar from 'components/Search/SearchBar'
import SearchMap from 'components/Search/Map'
import SearchClient from 'services/search'
import MapService from 'services/map'
import I18n from 'locales'
import VisualizeButton from 'components/Search/Map/VisualizeButton'
import DrawButton from 'components/Search/Map/DrawButton'
import StopDrawingButton from 'components/Search/Map/StopDrawingButton'
import {
  businessTypeEnum,
  getSearchParams as SEARCH,
  REALTY_OPTIONS,
  AUDIT_OPTIONS,
} from 'constants/search'
import { SearchProvider } from 'context/Search'
import * as auth from 'services/auth'
import { Button } from 'components/Buttons'
import Spinner from 'components/Spinner'
import { ShowRealty } from 'components/ShowRealty'
import { ShowValuated } from 'components/ShowValuated'
import { MAP } from 'constants/map'
import MarkerContainer from 'components/MarkerContainer'
import InfoWindow from 'components/InfoWindow'
import { RealtyProvider } from 'context/Realty'
import { getAmenities } from 'services/filter'
import { Row, Col } from 'components/Grid'
import { Formik } from 'components/Form'
import baseCities from 'constants/cities'
import Statistics from 'components/Statistics'
import { callRequest, authHandler } from 'services/requestHandler'
import { formatRealties } from 'utils/formatRealties'
import classNames from 'classnames'
import Helmet from 'react-helmet'
import React, { Component, Fragment } from 'react'
import './index.css'

class Search extends Component {
  constructor(props, context) {
    super(props, context)

    this.client = new SearchClient()
    this.state = {
      search: SEARCH(),
      adsClusters: [],
      valuatedClusters: [],
      infoWindowVisible: false,
      infoWindowContent: null,
      prevSearch: JSON.stringify({ ...SEARCH() }),
      mapOptions: {},
      neighborhoods: {},
      error: {
        category: false,
        businessType: false,
      },
      adsCount: 0,
      valuatedCount: 0,
      radiusPinLatLng: null,
      loading: false,
      showRealty: false,
      optionalsFilter: [],
      realties: [],
      pristine: true,
      radiusInfo: false,
      selectedAddress: {},
      adsNeighborhoodStatistics: [],
      valuatedNeighborhoodStatistics: [],
      loadedNeighborhoods: [],
      statistics: false,
      sidebar: false,
      addressChanged: false,
      similarityFiltersChanged: false,
    }
    this.Materialize = window.M
    this.idList = []
    this.filters = null
    !auth.getCityIdLocalStorage() && auth.setCityIdLocalStorage(auth.cityId())
  }

  componentDidMount() {
    callRequest(
      () => getAmenities(),
      data => this.setOptionals(data),
      null,
      this.handleError,
    )
  }

  changeCity = cityId => {
    auth.setCityIdLocalStorage(cityId)
    this.resetMap()
  }

  clearDrawing = () => {
    this.setState(state => ({
      ...state,
      search: { ...state.search, drawing: false },
      adsClusters: [],
      valuatedClusters: [],
    }))
    this.mapService.stopDrawing()
    this.mapService.clearPolygons()
    this.resetMap()
    this.callUpdate()
  }

  drawPolygon = () => {
    if (this.mapService) {
      this.startDrawing()
      this.mapService.drawPolygon()
    }
  }

  drawFreeHand = () => {
    if (this.mapService) {
      this.startDrawing()
      this.mapService.drawFreeHand()
    }
  }

  formatStateForQuery = () => {
    const {
      search: {
        priceRange,
        sqrMtrPriceRange,
        businessType,
        valuatedType,
        more,
        query,
        category,
        privateBusiness,
      },
      formattedAddress,
      selectedAddress,
    } = this.state
    const polygon = this.mapService.getPolygonsAsArray()

    let priceType
    if (businessType) {
      switch (businessTypeEnum(businessType).value) {
        case 2:
          priceType = 'transaction_rent'
          break
        case 3:
          priceType = 'transaction_season'
          break
        default:
          priceType = 'transaction_sale'
          break
      }
    }

    const aggregations = [
      { type: 'percentiles', field: priceType, value: 'price' },
      { type: 'percentiles', field: 'area', value: 'area' },
      { type: 'percentiles', field: 'total_area', value: 'totalArea' },
      { type: 'max', field: 'neighborhood_id', value: 'neighborhoodId' },
    ]
    const source = [
      'location',
      'link_key',
      'type',
      'processed_address_formatted',
      'neighborhood_name',
      'transaction_sale',
      'transaction_rent',
      'feature_bedroom',
      'feature_garage',
      'area',
      'created_at',
    ]
    const { garage, area } = this.filters || {}
    const similarityFilters =
      this.filters && selectedAddress
        ? {
            garage: garage || undefined,
            area: area || undefined,
            transaction: priceType.replace('transaction_', ''),
            address: formattedAddress,
            coordinates: selectedAddress?.location
              ? [selectedAddress.location.lng(), selectedAddress.location.lat()]
              : undefined,
          }
        : undefined

    return {
      priceRange,
      sqrMtrPriceRange,
      businessType: priceType,
      polygon,
      query,
      category,
      aggregations,
      source,
      valuatedType,
      privateBusiness,
      similarityFilters,
      ...more,
    }
  }

  getWarningMessage = () => {
    const { category, valuatedType, businessType } = this.state.error

    if (category && (businessType || valuatedType))
      return I18n.t('warningMessages.noBusinessAndCategory')

    if ((!businessType || !valuatedType) && category)
      return I18n.t('warningMessages.noCategory')

    if ((businessType || valuatedType) && !category)
      return I18n.t('warningMessages.noBusiness')

    return I18n.t('warningMessages.noBusinessAndCategory')
  }

  setOptionals = optionals => {
    this.setState(state => ({ ...state, optionalsFilter: optionals }))
  }

  handleMapChange = mapOptions => {
    this.setState(
      {
        mapOptions,
      },
      () => {
        if (
          !this.mapService ||
          (!this.mapService.adsClusterExists &&
            !this.mapService.valuatedClusterExists)
        ) {
          return
        }

        const { adsClusters, valuatedClusters } = this.state
        const newAdsClusters =
          this.mapService.adsClusterExists &&
          this.mapService.getClusters(mapOptions, 'isAds')
        const shouldUpdateAds =
          JSON.stringify(adsClusters) !== JSON.stringify(newAdsClusters)

        const newValuatedClusters =
          this.mapService.valuatedClusterExists &&
          this.mapService.getClusters(mapOptions)
        const shouldUpdateValuated =
          JSON.stringify(valuatedClusters) !==
          JSON.stringify(newValuatedClusters)

        let updateObj = { adsClusters, valuatedClusters }
        if (shouldUpdateAds) updateObj.adsClusters = newAdsClusters
        if (shouldUpdateValuated)
          updateObj.valuatedClusters = newValuatedClusters
        this.setState(updateObj)
      },
    )
  }

  handleGeocodeCallback = (status, { center, zoom }) => {
    if (status === 'OK') {
      this.panMap(zoom, center)
    } else {
      this.handleError(status)
    }
  }

  handleOnSearch = values => {
    const {
      sqrMtrPriceRange,
      priceRange,
      query,
      more,
      businessType,
      category,
      privateBusiness,
      valuatedType,
    } = values
    const price =
      priceRange && (priceRange.minPrice >= 0 || priceRange.maxPrice >= 0)
        ? priceRange
        : null
    const sqrMtrPrice =
      sqrMtrPriceRange &&
      (sqrMtrPriceRange.minPrice >= 0 || sqrMtrPriceRange.maxPrice >= 0)
        ? sqrMtrPriceRange
        : null

    this.setState(
      prevState => ({
        ...prevState,
        search: {
          ...prevState.search,
          businessType:
            businessType || businessType === ''
              ? businessType
              : prevState.search.businessType,
          valuatedType:
            valuatedType || valuatedType === ''
              ? valuatedType
              : prevState.search.valuatedType,
          privateBusiness:
            (privateBusiness === undefined &&
              prevState.search.privateBusiness) ||
            privateBusiness,
          priceRange: price ? price : prevState.search.priceRange,
          sqrMtrPriceRange: sqrMtrPrice
            ? sqrMtrPrice
            : prevState.search.sqrMtrPriceRange,
          query: query || prevState.search.query,
          more: { ...(more || prevState.search.more) },
          category: category || prevState.search.category,
        },
      }),
      () => this.validateSearch(),
    )

    if (query) {
      this.mapService.geocode(query, this.handleGeocodeCallback)
    }
  }

  handleSubmitSearch = () => {
    this.clearClusters()
    const options = this.formatStateForQuery()
    this.setState(state => ({
      ...state,
      loading: true,
      pristine: false,
      adsNeighborhoodStatistics: [],
      valuatedNeighborhoodStatistics: [],
    }))

    const doSearches = async () => {
      let searchRealties
      if (options.businessType && options.businessType !== '') {
        try {
          searchRealties = await this.client.searchV2(null, {
            ...options,
            size: 100000,
          })
        } catch (err) {
          if (err.response.status === 401) {
            searchRealties = await authHandler(
              err,
              async () =>
                await this.client.searchV2(null, {
                  ...options,
                  size: 100000,
                }),
            )
          } else {
            this.handleError(err)
            this.Materialize.toast({
              html: I18n.t('common.fail'),
              classes: 'Search__Toast--failure',
            })
          }

          this.setState({ loading: false })
        }
      }

      let searchValuated
      if (options.valuatedType && options.valuatedType !== '') {
        try {
          searchValuated = await this.client.searchV2('isAudit', {
            ...options,
            businessType: undefined,
            size: 100000,
          })
        } catch (err) {
          if (err.response.status === 401) {
            searchRealties = await authHandler(
              err,
              async () =>
                await this.client.searchV2(null, {
                  ...options,
                  size: 100000,
                }),
            )
          } else {
            this.handleError(err)
            this.Materialize.toast({
              html: I18n.t('common.fail'),
              classes: 'Search__Toast--failure',
            })
            this.setState({ loading: false })
          }
        }
      }

      return {
        searchRealties,
        searchValuated,
      }
    }

    doSearches().then(({ searchRealties = {}, searchValuated = {} }) => {
      this.setState(state => ({ ...state, loading: false }))

      const { data: realties } = searchRealties
      const { data: valuated } = searchValuated

      if (options.businessType && realties) {
        if (realties.hits) {
          this.parseResults(realties.hits, 'isAds')
        }

        const { aggregations: realtiesAggs } = realties
        if (realtiesAggs) {
          const { neighborhood: adsNeighborhood } = realtiesAggs
          this.setState({
            adsNeighborhoodStatistics: adsNeighborhood.buckets.sort((a, b) => {
              if (a.key < b.key) return -1
              if (a.key > b.key) return 1
              return 0
            }),
          })
        }
      }

      if (options.valuatedType && valuated) {
        if (valuated.hits) {
          this.parseResults(valuated.hits)
        }

        const { aggregations: valuatedAggs } = valuated
        if (valuatedAggs) {
          const { neighborhood: valuatedNeighborhood } = valuatedAggs
          this.setState({
            valuatedNeighborhoodStatistics: valuatedNeighborhood.buckets.sort(
              (a, b) => {
                if (a.key < b.key) return -1
                if (a.key > b.key) return 1
                return 0
              },
            ),
          })
        }
      }
    })
  }

  handleError = err => {
    console.error(err)
  }

  handleNeighborhoodsResponse = (
    { data },
    cityId = auth.getCityIdLocalStorage(),
    load = true,
  ) => {
    const neighborhoods = data.map(neighborhood => ({
      id: neighborhood.Id,
      name: neighborhood.Nome,
      path: this.mapService.decodePath(neighborhood.PontosPoligono),
      latLng: {
        lat: neighborhood.PontoCentralLatitude,
        lng: neighborhood.PontoCentralLongitude,
      },
    }))
    this.setState({ loadedNeighborhoods: neighborhoods })
    load &&
      this.mapService.loadNeighborhoods(neighborhoods, this.callUpdate, cityId)
  }

  handleZonesResponse = ({ data }) => {
    this.mapService.loadZones(
      data.map(zone => ({
        id: zone.Id,
        name: zone.Sigla,
        path: this.mapService.decodePath(zone.Encode[0]),
      })),
      this.callUpdate,
    )
  }

  handleSelectVisualization = (
    visualization = null,
    formover = null,
    cityId = auth.getCityIdLocalStorage(),
  ) => {
    const currentVisualization =
      visualization || this.state.search.visualization

    if (visualization && formover) {
      this.setState(
        state => ({ search: { ...state.search, visualization } }),
        () => formover.toggle(),
      )
    }

    this.setState({ radiusPinLatLng: null })
    this.mapService.clearMap()
    if (currentVisualization.neighborhoods) {
      this.mapService.selectedNeighborhoods.length === 0 &&
        !this.mapService.loadedNeighborhoods[cityId] &&
        callRequest(
          () => this.client.neighborhoods(cityId),
          data => this.handleNeighborhoodsResponse({ data }, cityId),
          null,
          this.handleError,
        )

      this.mapService.selectedNeighborhoods.length === 0 &&
        this.mapService.loadedNeighborhoods[cityId] &&
        this.mapService.renderNeighborhoods(cityId)

      this.mapService.selectedNeighborhoods.length > 0 &&
        this.mapService.stopSelecting()
    }

    if (currentVisualization.zones) {
      !this.mapService.loadedZones[cityId] &&
        callRequest(
          () => this.client.zones(cityId),
          data => this.handleZonesResponse({ data }),
          null,
          this.handleError,
        )
      this.mapService.loadedZones[cityId] && this.mapService.renderZones()
    }

    if (currentVisualization.satellite) {
      this.mapService.changeToSatelliteView()
    } else {
      this.mapService.changeToRoadmapView()
    }
  }

  handleClearFilters = () => {
    this.setState(
      state => ({
        ...state,
        search: { ...SEARCH() },
        prevSearch: JSON.stringify({ ...SEARCH() }),
        adsCount: 0,
        valuatedCount: 0,
        alert: false,
        pristine: true,
      }),
      () => {
        this.clearClusters()
        this.validateSearch(this.state.search)
      },
    )
  }

  handleSetPrevSearch = (prevSearch, submit, addressChanged) => {
    this.setState(state => ({
      ...state,
      prevSearch: JSON.stringify(prevSearch),
      addressChanged,
    }))
    submit && this.handleSubmitSearch()
  }

  callUpdate = () => {
    this.forceUpdate()
  }

  initializeMapService = google => {
    this.mapService = new MapService(google, this.callUpdate)
    auth.setCityIdLocalStorage(auth.cityId())
    this.handleSelectVisualization(
      null,
      null,
      baseCities[auth.cityId()] ? auth.cityId() : 5270,
    )
    if (baseCities[auth.cityId()]) {
      this.panMap(
        baseCities[auth.cityId()].zoom,
        baseCities[auth.cityId()].coordinates,
      )
    } else {
      auth.setCityIdLocalStorage(5270)
      this.panMap(baseCities[5270].zoom, baseCities[5270].coordinates)
      window.M.toast({
        html:
          'Infelizmente não conseguimos localizar sua cidade, redirecionamos você para São Paulo',
        classes: 'Toast--failure',
      })
    }
  }

  parseResults = ({ hits, total, ...rest }, isAds = false) => {
    if (!rest || !hits || hits.length === 0) {
      this.clearClusters(isAds)
      return
    }
    const { mapOptions } = this.state
    this.mapService.loadClusters(
      hits.map(realState => ({
        isAudit: !isAds,
        esIndex: realState._source.link_key,
        type: 'Feature',
        address: realState._source.processed_address_formatted,
        geometry: {
          type: 'Point',
          coordinates: realState._source.location.coordinates,
        },
      })),
      isAds,
    )
    let clusters = this.mapService.getClusters(mapOptions, isAds)
    this.setState(() =>
      isAds
        ? { adsClusters: clusters, adsCount: hits.length }
        : { valuatedClusters: clusters, valuatedCount: hits.length },
    )
  }

  shouldShowAlertButton = () => {
    const { prevSearch, search } = this.state
    const defaultSearch = JSON.stringify({ ...SEARCH() })
    const currentSearch = JSON.stringify({ ...search })
    return (
      prevSearch !== defaultSearch &&
      currentSearch !== defaultSearch &&
      !search.drawing
    )
  }

  stopDrawing = () => {
    if (this.mapService) {
      this.mapService.stopDrawing()
      this.setState(
        state => ({
          ...state,
          search: { ...state.search, drawing: false },
        }),
        () => {
          const { search } = this.state
          this.validateSearch(search)
        },
      )
    }
  }

  startDrawing = () => {
    this.clearClusters()
    this.mapService.resetMap()
    this.setState(state => ({
      search: { ...state.search, drawing: true },
      adsClusters: [],
      valuatedClusters: [],
    }))
  }

  toggleShowRealty = (isAudit = false) => {
    const { showRealty } = this.state
    this.idList = []
    this.setState(state => ({
      ...state,
      valuatedClick: isAudit,
      showRealty: !showRealty,
      realties: [],
    }))
  }

  toggleStatistics = () => {
    this.setState(state => ({
      ...state,
      statistics: !state.statistics,
    }))
  }

  toggleReportModal = () => {
    this.setState(state => ({
      ...state,
      reportModalVisible: false,
      reportRealtyId: null,
    }))
  }

  openReportModal = id => {
    this.setState(state => ({
      ...state,
      reportRealtyId: id,
      reportModalVisible: true,
    }))
  }

  validateSearch = (prevState = null, { addressChanged } = {}) => {
    const { businessType, valuatedType, category } = this.state.search
    let valid = true
    let categoryCount = 0

    if (category) {
      Object.keys(category).forEach(key => {
        if (category[key]) categoryCount++
      })
    }

    if (categoryCount === 0) {
      this.setState(state => ({
        ...state,
        error: { ...state.error, category: true },
      }))
      valid = false
    } else {
      this.setState(state => ({
        ...state,
        error: { ...state.error, category: false },
      }))
    }

    if (!businessType && !valuatedType) {
      this.setState(state => ({
        ...state,
        error: { ...state.error, businessType: true },
      }))
      valid = false
    } else {
      this.setState(state => ({
        ...state,
        error: { ...state.error, businessType: false },
      }))
    }

    if (prevState) this.handleSetPrevSearch(prevState, valid, addressChanged)
    if (!valid) {
      this.Materialize.toast({
        html: this.getWarningMessage(),
        classes: 'Search__Toast',
      })
    }
  }

  resetMap = city => {
    this.clearClusters()
    this.mapService.resetMap()
    const cityId = (Number(city) && city) || auth.getCityIdLocalStorage()
    this.state.infoWindowVisible && this.toggleInfoWindow()
    this.handleSelectVisualization()
    this.setState(({ mapOptions }) => ({
      adsNeighborhoodStatistics: [],
      valuatedNeighborhoodStatistics: [],
      statistics: false,
      adsCount: 0,
      valuatedCount: 0,
      pristine: true,
      radiusPinLatLng: null,
      radiusInfo: false,
      mapOptions: {
        ...mapOptions,
        center: baseCities[cityId].coordinates,
        zoom: baseCities[cityId].zoom,
      },
    }))
    this.callUpdate()
  }

  getOffset(zoom) {
    switch (zoom) {
      case 14:
        return 0.009
      case 15:
        return 0.007
      case 16:
        return 0.003
      case 17:
        return 0.0015
      case 18:
        return 0.0007
      case 19:
        return 0.00035
      case 20:
        return 0.00016
      default:
        return 0.009
    }
  }

  handlePinOnClick = pin => {
    const {
      mapOptions: { zoom },
      search: { businessType, valuatedType },
    } = this.state
    const newLat = pin.geometry.coordinates[1] + this.getOffset(zoom)
    this.panMap(this.state.mapOptions.zoom, [
      newLat,
      pin.geometry.coordinates[0],
    ])
    this.setState(
      {
        lastClickedPin: pin.geometry.coordinates,
        infoWindowVisible: true,
        infoWindowContent: null,
      },
      () => {
        this.client
          .realtyById({
            id: pin.esIndex,
            isAudit: pin.isAudit,
            source: pin.isAudit ? AUDIT_OPTIONS : REALTY_OPTIONS,
          })
          .then(({ data }) => {
            if (data.hits && data.hits.hits) {
              formatRealties(
                data.hits.hits,
                businessType,
                valuatedType,
                this.formatRealtiesInfoWindowCallback,
                pin.isAudit,
              )
            }
          })
      },
    )
  }

  toggleInfoWindow = () => {
    this.setState({
      infoWindowContent: null,
      infoWindowVisible: !this.state.infoWindowVisible,
    })
  }

  renderRadiusMarker = point => {
    return (
      <MarkerContainer
        key={point.address}
        lat={point.lat}
        lng={point.lng}
        title={point.address}
      >
        <Marker fillColor="green" />
      </MarkerContainer>
    )
  }

  renderMarkers = () => {
    let { adsClusters, valuatedClusters } = this.state
    if (!adsClusters.length && !valuatedClusters.length) return undefined

    const zoomClick = (id, geometry, isAudit) => {
      this.panMap(
        Math.floor(
          this.mapService.getClusterExpansionZoom(id, !isAudit) + 2,
          MAP.options.maxZoom,
        ),
        geometry,
      )
    }

    const zoomedClick = (clusterId, isAudit) => {
      this.toggleShowRealty(isAudit)
      this.idList = this.mapService
        .getClusterLeaves(clusterId, isAudit)
        .map(leaf => leaf.esIndex)
      this.handlePageChange({
        isAudit,
        id: this.idList,
        sort: {
          created_at: 'desc',
          _id: 'asc',
        },
      })
    }

    if (!valuatedClusters) valuatedClusters = []
    if (!adsClusters) adsClusters = []

    return adsClusters
      .concat(valuatedClusters.map(item => ({ ...item, isAudit: true })))
      .map((item, index) => {
        const { properties, geometry, address, isAudit } = item

        return (
          <MarkerContainer
            key={index}
            title={!properties ? address : null}
            lat={geometry.coordinates[1]}
            lng={geometry.coordinates[0]}
          >
            {!properties ? (
              <Marker
                fillColor={isAudit ? 'red' : undefined}
                onClick={() => this.handlePinOnClick(item)}
              />
            ) : (
              <ClusterMarker
                zoomClick={() =>
                  zoomClick(
                    properties.cluster_id,
                    geometry.coordinates.reverse(),
                    isAudit,
                  )
                }
                isAudit={isAudit}
                zoomedClick={() => zoomedClick(properties.cluster_id, isAudit)}
                currentZoom={this.state.mapOptions.zoom}
                pointsCount={properties.point_count_abbreviated}
              />
            )}
          </MarkerContainer>
        )
      })
  }

  formatRealtiesCallback = ({ data }) => {
    this.setState({ realties: data })
  }

  formatRealtiesInfoWindowCallback = ({ data }) => {
    this.setState({ infoWindowContent: data[0] })
  }

  clearClusters = isAds => {
    if (isAds === undefined) {
      this.setState({
        adsClusters: [],
        valuatedClusters: [],
        adsCount: 0,
        valuatedCount: 0,
      })
      this.mapService.clearClusters()
    } else {
      this.setState(
        isAds
          ? {
              adsClusters: [],
              adsCount: 0,
            }
          : { valuatedClusters: [], valuatedCount: 0 },
      )
      this.mapService.clearClusters(isAds, !isAds)
    }
  }

  renderMapButtons = () => {
    const {
      search: { visualization, drawing },
    } = this.state
    return (
      <div className="Search__MapBtnContainer">
        {!drawing &&
          this.mapService &&
          !this.mapService.isSelectingNeighborhoods && (
            <div className="Search__ButtonContainer">
              <VisualizeButton
                onSubmit={this.handleSelectVisualization}
                initialValues={visualization}
                zoning={
                  baseCities[auth.getCityIdLocalStorage()] &&
                  baseCities[auth.getCityIdLocalStorage()].zoning
                }
              />
            </div>
          )}
        {this.mapService && !this.mapService.isSelectingNeighborhoods && (
          <div className="Search__ButtonContainer">
            {!drawing ? (
              <DrawButton
                drawPolygon={this.drawPolygon}
                drawFreeHand={this.drawFreeHand}
              />
            ) : (
              <Fragment>
                <StopDrawingButton onClick={this.stopDrawing} />
                <Button
                  className="Search__MapButton"
                  onClick={this.clearDrawing}
                >
                  <i className="material-icons">close</i>
                  {I18n.t('components.actions.cancel')}
                </Button>
              </Fragment>
            )}
          </div>
        )}
        <div>
          {this.mapService && this.mapService.polygons.length !== 0 && (
            <Button className="Search__MapButton" onClick={this.resetMap}>
              <i className="material-icons">autorenew</i>
              {I18n.t('components.filters.resetMap')}
            </Button>
          )}
        </div>
        {this.mapService &&
          this.mapService.selectedNeighborhoods.length > 0 &&
          this.mapService.polygons.length === 0 &&
          !this.state.search.drawing && (
            <Button
              className="Search__MapButton Search__Animated"
              onClick={this.selectNeighborhoods}
            >
              <i className="material-icons">check</i>
              {I18n.t('components.actions.apply')}
            </Button>
          )}
      </div>
    )
  }

  selectNeighborhoods = () => {
    this.mapService.stopSelecting()
    this.validateSearch(this.state.search)
  }

  handleShowRealtyBtnClick = isAds => {
    let options = {
      ...this.formatStateForQuery(),
      isAds,
      source: isAds ? REALTY_OPTIONS : AUDIT_OPTIONS,
      aggregations: undefined,
      filterPaths: ['hits.*'],
    }
    this.toggleShowRealty(!isAds)
    this.handlePaginatedSearch(options)
  }

  handlePageChange = ({ isAudit, sort, searchAfter, query, id }, callback) => {
    let options = {
      ...this.formatStateForQuery(),
      sort,
      searchAfter,
      query,
      id,
      isAds: !isAudit,
      source: isAudit ? AUDIT_OPTIONS : REALTY_OPTIONS,
      aggregations: undefined,
      filterPaths: ['hits.*'],
    }
    this.handlePaginatedSearch(options, callback)
  }

  handlePaginatedSearch = (options, callback = null) => {
    const { businessType, valuatedType } = this.state.search
    const { isAds } = options
    let response = null
    const doReq = async () => {
      try {
        response = await this.client.searchV2(!isAds, options)
      } catch (err) {
        if (err.response.status === 401) {
          response = authHandler(
            err,
            async () => await this.client.searchV2(!isAds, options),
          )
        }
        this.handleError(err)
      }
      return response
    }

    doReq()
      .then(({ data }) => {
        if (data) {
          const { hits } = data
          const visitedUrls = JSON.parse(
            localStorage.getItem('EEMOVEL_VISITED_ADS'),
          )
          this.setState({ totalRealties: hits.total.value })
          hits.hits &&
            formatRealties(
              hits.hits,
              businessType,
              valuatedType,
              this.formatRealtiesCallback,
              !isAds,
              visitedUrls || {},
            )
        }
      })
      .then(() => callback && callback())
  }

  panMap = (zoom, center) => {
    this.setState(({ mapOptions }) => ({
      mapOptions: {
        ...mapOptions,
        zoom,
        center,
      },
    }))
  }

  closeRadiusInfo = () => {
    this.setState(state => ({ ...state, radiusInfo: false }))
  }

  setRadiusInfo = (selectedAddress, address, formattedAddress) => {
    !this.mapService.getPolygons().filter(x => !x.radius).length &&
      this.resetMap()
    this.setState(state => ({
      ...state,
      selectedAddress,
      formattedAddress,
      addressChanged: formattedAddress !== state.formattedAddress,
      radiusPinLatLng: {
        address,
        lat: selectedAddress.location.lat(),
        lng: selectedAddress.location.lng(),
      },
      radiusInfo: true,
    }))
  }

  changeRadius = ({ radius }) => {
    const { selectedAddress } = this.state
    const parsedRadius = Number(radius)
    this.mapService.createCircle(
      {
        lat: selectedAddress.location.lat(),
        lng: selectedAddress.location.lng(),
      },
      parsedRadius,
    )
    this.panMap(this.state.mapOptions.zoom, {
      lat: selectedAddress.location.lat(),
      lng: selectedAddress.location.lng(),
    })
    this.closeRadiusInfo()
    // this.validateSearch(this.state.search)
  }

  renderRadiusInfo = () => {
    if (this.mapService?.getPolygons().filter(x => !x.radius).length)
      return undefined
    const { radiusInfo } = this.state
    const radiusClasses = classNames({
      'Search__Pane--hidden': !radiusInfo,
      Search__Pane: radiusInfo,
    })
    return (
      <div className={radiusClasses}>
        <div className="Search__Radius">
          <Row end="xs">
            <Col xs={12}>
              <i className="material-icons" onClick={this.closeRadiusInfo}>
                close
              </i>
            </Col>
          </Row>
          <div className="Search__RadiusContainer">
            <span>Em um raio de quantos metros você deseja procurar?</span>
            <Formik
              initialValues={{ radius: 250 }}
              onSubmit={this.changeRadius}
            >
              {({ handleSubmit, handleChange, values: { radius } }) => (
                <form onSubmit={handleSubmit}>
                  <input name="radius" value={radius} onChange={handleChange} />
                  <Button type="submit" btnStyle="primary" btnSize="xs" compact>
                    <i className="material-icons">check</i>
                  </Button>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    )
  }

  handleViewAdClick = id => {
    const { realties } = this.state

    let visitedUrls =
      JSON.parse(localStorage.getItem('EEMOVEL_VISITED_ADS')) || {}
    visitedUrls[id] = new Date()
    localStorage.setItem('EEMOVEL_VISITED_ADS', JSON.stringify(visitedUrls))

    const realty = realties.find(item => item.Id === id)
    realty.Visited = true

    this.setState({ realties })
  }

  renderGadgets = () => {
    const {
      loading,
      showRealty,
      realties,
      totalRealties,
      isAds,
      radiusInfo,
      valuatedClick,
      search: { drawing, businessType, valuatedType, more },
    } = this.state
    return (
      <Fragment>
        <Spinner visible={loading} />
        {showRealty && (
          <RealtyProvider
            value={{
              realties,
              totalRealties,
              businessType,
              isAds,
              recentOnly: more.recentOnly,
              idList: this.idList,
              visible: showRealty,
              handlePageChange: this.handlePageChange,
              handleViewAdClick: this.handleViewAdClick,
              toggle: this.toggleShowRealty,
            }}
          >
            {valuatedClick ? (
              <ShowValuated valuatedType={valuatedType} />
            ) : (
              <ShowRealty businessType={businessType} />
            )}
          </RealtyProvider>
        )}
        {radiusInfo && this.renderRadiusInfo()}
        {this.mapService &&
          (this.mapService.isSelectingNeighborhoods || drawing) && (
            <div className="Search__GlassPane" />
          )}
      </Fragment>
    )
  }

  toggleFilterBar = () => {
    const { sidebar } = this.state
    this.setState({ sidebar: !sidebar })
  }

  setFilterValues = values => {
    const currentFilters = JSON.stringify(this.filters)
    const newFilters = JSON.stringify(values)
    let similarityFiltersChanged = false
    if (newFilters !== currentFilters) {
      this.filters = values
      similarityFiltersChanged = true
    }
    this.setState({ similarityFiltersChanged })
  }

  render() {
    const {
      mapOptions,
      prevSearch,
      error,
      search,
      loading,
      infoWindowVisible,
      lastClickedPin,
      infoWindowContent,
      optionalsFilter,
      adsCount,
      valuatedCount,
      pristine,
      statistics,
      adsNeighborhoodStatistics,
      valuatedNeighborhoodStatistics,
      reportRealtyId,
      reportModalVisible,
      loadedNeighborhoods,
      radiusPinLatLng,
      sidebar,
      selectedAddress,
      similarityFiltersChanged,
      addressChanged,
      formattedAddress,
    } = this.state
    const {
      query,
      businessType,
      privateBusiness,
      drawing,
      priceRange,
      sqrMtrPriceRange,
      more,
      category,
      visualization,
      valuatedType,
    } = search
    const { center, zoom } = mapOptions
    const mapContainer = classNames({
      Search__MapContainer: !statistics,
      'Search__MapContainer--active': statistics,
    })
    const sideContainer = classNames('Search__SideContainer', {
      'Search__SideContainer--active': statistics,
    })
    return (
      <SearchProvider
        value={{
          filters: {
            valuatedType,
            businessType,
            privateBusiness,
            drawing,
            priceRange,
            sqrMtrPriceRange,
            more,
            category,
          },
          shouldRenderSearch: addressChanged || similarityFiltersChanged,
          formattedAddress,
          addressChanged,
          Materialize: this.Materialize,
          client: this.client,
          dwellerService: this.dwellerService,
          changeCity: this.changeCity,
          mapService: this.mapService,
          handleGeocodeCallback: this.handleGeocodeCallback,
          setRadiusInfo: this.setRadiusInfo,
          clearFilters: this.handleClearFilters,
          onSubmit: this.handleOnSearch,
          onSearch: this.handleSubmitSearch,
          setPrevSearch: this.validateSearch,
          polygons: this.mapService ? this.mapService.getPolygonsAsArray() : [],
          adsCount,
          valuatedCount,
          visualization,
          prevSearch,
          error,
          optionalsFilter,
          openDwellers: this.toggleDwellers,
          query,
          loadedNeighborhoods,
          clearClusters: this.clearClusters,
        }}
      >
        <PageBase
          fluid
          className="Search"
          TopComponent={() => (
            <div className="Search__Bars">
              <SearchBar />
            </div>
          )}
        >
          <Helmet>
            <title>EEmovel - {I18n.t('pages.search.title')}</title>
          </Helmet>
          {((adsCount || valuatedCount) && !loading && (
            <div className="Search__ShowRealtyBar">
              <div className="Search__ShowRealtyBar__Container">
                <div className="Search__ShowRealtyBar__Count">
                  {adsCount > 0 && (
                    <Fragment>
                      {I18n.t('components.filters.foundAds')}
                      <span
                        className="Search__ShowRealtyBar__Count__Text"
                        onClick={() => this.handleShowRealtyBtnClick('isAds')}
                      >{`${adsCount.toLocaleString('pt-BR')}${
                        adsCount === 10000 ? ' ou mais' : ''
                      } anúncio(s)`}</span>
                    </Fragment>
                  )}
                  {valuatedCount > 0 && (
                    <Fragment>
                      {`${adsCount > 0 ? ' - ' : ''}${I18n.t(
                        'components.filters.foundValuated',
                      )}`}
                      <span
                        className="Search__ShowRealtyBar__Count__Text"
                        onClick={() => this.handleShowRealtyBtnClick()}
                      >{`${valuatedCount.toLocaleString('pt-BR')}${
                        valuatedCount === 10000 ? ' ou mais' : ''
                      } leilões(s)`}</span>
                    </Fragment>
                  )}
                </div>
                {adsCount > 0 && (
                  <Button
                    className="Search__ShowRealtyBar__ShowRealtyBtn"
                    onClick={() => this.handleShowRealtyBtnClick('isAds')}
                  >
                    <i className="material-icons">location_city</i>
                    {I18n.t('components.showRealtyBtn.show')}
                  </Button>
                )}
                {valuatedCount > 0 && (
                  <Button
                    className="Search__ShowRealtyBar__ShowRealtyBtn"
                    onClick={() => this.handleShowRealtyBtnClick()}
                  >
                    <i className="material-icons">location_city</i>
                    {I18n.t('components.showRealtyBtn.showAudit')}
                  </Button>
                )}

                {(adsNeighborhoodStatistics.length > 0 ||
                  valuatedNeighborhoodStatistics.length > 0) &&
                  !statistics && (
                    <Button
                      className="Search__ShowRealtyBar__ShowRealtyBtn"
                      onClick={this.toggleStatistics}
                    >
                      <i className="material-icons">poll</i>
                      Estatísticas
                    </Button>
                  )}
              </div>
            </div>
          )) ||
            (!adsCount && !valuatedCount && !pristine && !loading && (
              <div className="Search__ShowRealtyBar">
                <div className="Search__ShowRealtyBar__Container">
                  <div className="Search__ShowRealtyBar__NotFound">
                    <div>{I18n.t('components.showRealty.noRealtyFound')}</div>
                  </div>
                </div>
              </div>
            ))}
          <div className="Search__ContentContainer">
            <FilterBar
              formattedAddress={formattedAddress}
              disabled={!selectedAddress?.location}
              active={sidebar}
              toggleFilterBar={this.toggleFilterBar}
              setFilterValues={this.setFilterValues}
              loading={loading}
            />
            <div className={mapContainer}>
              <SearchMap
                onChange={this.handleMapChange}
                useMapsApi
                onGoogleApiLoaded={this.initializeMapService}
                streetViewControl
                zoom={zoom}
                maxZoom={MAP.options.maxZoom}
                center={center}
                visualization={visualization}
              >
                {radiusPinLatLng && this.renderRadiusMarker(radiusPinLatLng)}
                {this.renderMarkers()}
                {infoWindowVisible && (
                  <InfoWindow
                    reportRealtyId={reportRealtyId}
                    reportModalVisible={reportModalVisible}
                    toggleReportModal={this.toggleReportModal}
                    openReportModal={this.openReportModal}
                    toggleInfoWindow={this.toggleInfoWindow}
                    content={infoWindowContent || 'Carregando...'}
                    lat={lastClickedPin ? lastClickedPin[1] : null}
                    lng={lastClickedPin ? lastClickedPin[0] : null}
                    businessType={businessType}
                    valuatedType={valuatedType}
                  />
                )}
              </SearchMap>
              {this.renderMapButtons()}
            </div>
            <div className={sideContainer}>
              {statistics && (
                <Statistics
                  adsNeighborhoodStatistics={adsNeighborhoodStatistics}
                  valuatedNeighborhoodStatistics={
                    valuatedNeighborhoodStatistics
                  }
                  active={statistics}
                  close={this.toggleStatistics}
                />
              )}
            </div>
          </div>
          {this.renderGadgets()}
        </PageBase>
      </SearchProvider>
    )
  }
}

export default Search
